import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  GetIconForField,
  RemoveEmptyIds,
  DeleteFormFieldUtil,
  ModifyFromFieldUtil,
} from "./form-design-util";
import FluentUiIcon from "../../../../../../assets/fluent-ui-icon";
import { CreateEditField } from "../common-components/create-edit-field";

export const ModifyFormSectionItem = ({
  number,
  field,
  allForms,
  currentForm,
  setAllForms,
  subForm,
  fieldLength,
  index
}) => {
  const [dialog, setDialog] = useState(false);

  const SaveField = (currentField) => {
    const newAllForms = ModifyFromFieldUtil(
      allForms.data,
      currentForm.DisplayOrder,
      subForm.DisplayOrder,
      currentField
    );

    setAllForms((prev) => ({
      ...prev,
      data: newAllForms,
    }));
    setDialog(false);
  };

  const changeOrder = (currentField,direction) => {
    const newAllForms = ModifyFromFieldUtil(
      allForms.data,
      currentForm.DisplayOrder,
      subForm.DisplayOrder,
      currentField,
      direction
    );

    setAllForms((prev) => ({
      ...prev,
      data: newAllForms,
    }));
  };

  const DeleteField = (currentField) => {
    const { newAllForms, newFieldId } = DeleteFormFieldUtil(
      allForms.data,
      currentForm.DisplayOrder,
      subForm.DisplayOrder,
      currentField
    );

    setAllForms((prev) => ({
      ...prev,
      DynamicFormFieldIdsToBeDeleted: RemoveEmptyIds(
        prev.DynamicFormFieldIdsToBeDeleted,
        newFieldId
      ),
      data: newAllForms,
    }));
    setDialog(false);
  };

  return (
    <div className="modify-form-content-section-item" id = {`animate-${subForm.DisplayOrder}-${number}`}>
      <div className="modify-form-content-section-item-info">
        <div className="modify-form-content-section-item-info-number">
          {number}
        </div>
        <div className="modify-form-content-section-item-info-icon">
          <FluentUiIcon
            name={GetIconForField(field.FieldType)}
            color={"#605E5C"}
            size={20}
          />
        </div>
        {field.LocalLabel}
        <div
          className={`modify-form-content-section-item-info-state ${
            field.IsDisabled ? "readonly" : "editable"
          }`}
        >
          {field.IsDisabled ? "Read-only" : "Editable"}
        </div>
      </div>

      <div className="field-buttons">
        {index !== 0 && <div onClick={() => changeOrder(field,"up")} >
          <FluentUiIcon
            name={"ChevronUpRegular"}
            color={"#605E5C"}
            size={20}
          />
        </div>}

        {index !== fieldLength-1 &&<div onClick={() => changeOrder(field,"down")}>
          <FluentUiIcon
            name={"ChevronDownRegular"}
            color={"#605E5C"}
            size={20}
          />
        </div>}
        <div onClick={() => setDialog(true)}>
          <FluentUiIcon
            name={"ChevronRightRegular"}
            color={"#605E5C"}
            size={20}
          />
        </div>
      </div>
      
      {dialog && (
        <CreateEditField
          field={field}
          open={dialog}
          OnCancel={() => setDialog(false)}
          SaveField={SaveField}
          DeleteField={DeleteField}
        />
      )}
    </div>
  );
};

ModifyFormSectionItem.propTypes = {
  number: PropTypes.number,
  field: PropTypes.object,
  allForms: PropTypes.object,
  currentForm: PropTypes.object,
  setAllForms: PropTypes.func,
  subForm: PropTypes.object,
  fieldLength: PropTypes.number,
  index: PropTypes.number
};
